import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";

export const getAllProducts = createAsyncThunk(
  "adminProducts/getAllProducts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Product";
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const createProduct = createAsyncThunk(
  "adminProducts/createProduct",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Product";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: payload.name,
          points: parseInt(payload.pointsNeeded),
          alias: payload.aliases,
          picture: payload.photo,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const updateProduct = createAsyncThunk(
  "adminProducts/updateProduct",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Product/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: payload.name,
          points: parseInt(payload.pointsNeeded),
          alias: payload.aliases,
          picture: payload.photo,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const deleteProduct = createAsyncThunk(
  "adminProducts/deleteProduct",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Product/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "DELETE",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  allDefinedProducts: null,
  getAllProductsLoading: "IDLE",
  getAllProductsError: null,
  createProductLoading: "IDLE",
  createProductError: null,
  updateProductLoading: "IDLE",
  updateProductError: null,
  deleteProductLoading: "IDLE",
  deleteProductError: null,
};

export const adminProductsSlice = createSlice({
  name: "adminProducts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllProducts.pending, (state, action) => {
      state.getAllProductsLoading = "PENDING";
      state.getAllProductsError = null;
    });
    builder.addCase(getAllProducts.fulfilled, (state, action) => {
      state.getAllProductsLoading = "SUCCESS";
      state.getAllProductsError = null;
      state.allDefinedProducts = action.payload.results;
    });
    builder.addCase(getAllProducts.rejected, (state, action) => {
      state.getAllProductsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllProductsError = err;
    });

    builder.addCase(createProduct.pending, (state, action) => {
      state.createProductLoading = "PENDING";
      state.createProductError = null;
    });
    builder.addCase(createProduct.fulfilled, (state, action) => {
      state.createProductLoading = "SUCCESS";
      state.createProductError = null;
    });
    builder.addCase(createProduct.rejected, (state, action) => {
      state.createProductLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.createProductError = err;
    });

    builder.addCase(updateProduct.pending, (state, action) => {
      state.updateProductLoading = "PENDING";
      state.updateProductError = null;
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.updateProductLoading = "SUCCESS";
      state.updateProductError = null;
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.updateProductLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.updateProductError = err;
    });

    builder.addCase(deleteProduct.pending, (state, action) => {
      state.deleteProductLoading = "PENDING";
      state.deleteProductError = null;
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      state.deleteProductLoading = "SUCCESS";
      state.deleteProductError = null;
    });
    builder.addCase(deleteProduct.rejected, (state, action) => {
      state.deleteProductLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.deleteProductError = err;
    });
  },
});

// this is for dispatch
export const {} = adminProductsSlice.actions;

// this is for configureStore
export default adminProductsSlice.reducer;
